import React, { useState, useEffect } from "react";

export const svg = `<svg width="36" height="32" viewbox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M.872 4.368C0 6.08 0 8.32 0 12.8v6.4c0 4.48 0 6.72.872 8.432a8 8 0 0 0 3.496 3.496C6.08 32 8.32 32 12.8 32h10.4c4.48 0 6.72 0 8.432-.872a8 8 0 0 0 3.496-3.496C36 25.92 36 23.68 36 19.2v-6.4c0-4.48 0-6.72-.872-8.432A8 8 0 0 0 31.632.872C29.92 0 27.68 0 23.2 0H12.8C8.32 0 6.08 0 4.368.872A8 8 0 0 0 .872 4.368ZM7.11 8.336a2 2 0 1 0-2.22 3.328l12 8a2 2 0 0 0 2.22 0l12-8a2 2 0 1 0-2.22-3.328L18 15.596 7.11 8.336Z" fill="currentColor"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
